import { useEffect } from "react";
import { useAppDispatch } from "hooks";
import { useNavigate } from "react-router-dom";
import { adminLogout, setAdminLoggedIn } from "State/admin_actions";

const AdminLogout = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(adminLogout());
    dispatch(setAdminLoggedIn(false));
    navigate("/admin-login");
  }, [dispatch, navigate]);

  return null;
};

export default AdminLogout;
